import { Component, Vue, Prop } from "vue-property-decorator";
import { Action } from "vuex-class";
import Loader from "@/components/Includes/Loader/Loader.vue";
import IAppConfig from "@/interfaces/astrology/appConfig/IAppConfig";

@Component({
  components: {
    Loader,
  },
})
export default class AppConfig extends Vue {
  @Action private readonly fetchAppConfig!: (id: number) => Promise<IAppConfig>;
  @Action private readonly createAppConfig!: (
    data: IAppConfig
  ) => Promise<void>;
  @Action private readonly deleteAppConfig!: (id: number) => Promise<void>;
  @Action private readonly updateAppConfig!: (
    data: IAppConfig
  ) => Promise<IAppConfig>;

  @Prop({ type: Number })
  private readonly id?: number;

  private loading = false;
  private appConfig: IAppConfig = { name: "", value: "" };

  private get isCreate() {
    return !this.id;
  }

  private get title() {
    if (this.isCreate) {
      return "Create AppConfig";
    }

    return `Edit AppConfig (ID: ${this.id})`;
  }

  private async actionAppConfig(action: "update" | "delete" | "create") {
    this.loading = true;

    try {
      switch (action) {
        case "update":
          await this.updateAppConfig(this.appConfig);
          this.$emit("updated");
          break;

        case "delete":
          if (this.id) {
            await this.deleteAppConfig(this.id);
            this.$emit("deleted");
          }
          break;

        default:
          await this.createAppConfig(this.appConfig);
          this.$emit("created");
          break;
      }
    } catch (error) {
      console.error(error);
    }

    this.loading = false;
  }

  private async created() {
    if (this.id) {
      this.loading = true;
      this.appConfig = await this.fetchAppConfig(this.id);
      this.loading = false;
    }
  }
}
